export function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white pt-20 pb-10 border-t border-white/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between gap-12 mb-16">
          <div className="space-y-4 max-w-sm">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-bold">
                Z
              </div>
              <span className="text-xl font-bold">Z App</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              The ultimate super app combining 13 powerful modes into one seamless platform.
            </p>
          </div>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">© 2025 Z App Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
